<template>
  <div class="pageNotFound">
    <p class="first-title">ページが見つかりませんでした。</p>
    <p class="second-title">
      お探しのページはアドレスが間違っている可能性があります。
    </p>
    <p>
      <span class="go-home" @click="goHome">
        ホームに戻る
      </span>
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentUser: null,
    };
  },
  async created () {
    this.currentUser = this.$store.state.user;
  },
  methods: {
    goHome () {
      if (this.currentUser.email !== "") {
        if (this.currentUser.role === "ADMIN") {
          this.$router.push("/admin/dashboard");
        } else {
          this.$router.push("/home");
        }
      } else {
        this.$router.push("/sign-in");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.go-home {
  font-size: 1.3em;
  font-weight: bolder;
  color: deepskyblue;
  cursor: none;
  text-decoration-line: underline;
}
.go-home:hover {
  font-size: 1.3em;
  font-weight: bolder;
  color: dodgerblue;
  text-decoration-line: underline;
  cursor: pointer;
}
.pageNotFound {
  margin-top: 6rem;
  text-align: center;
}
.pageNotFound .first-title {
  font-size: 1.5em;
  letter-spacing: 2px;
  font-weight: bold;
  margin: 0;
}
.pageNotFound .second-title {
  font-size: 15px;
  letter-spacing: 2px;
  text-shadow: 0.5px 0 0 currentColor;
}
</style>
